import axios from "./axiosInstance";

const formAPI = {
  getDetails: (params) => axios.get("form/", {params}),
  
  addForm: (payload) => axios.post("form/", payload),

  updateDetails: (id, payload) => axios.put(`form/${id}`, payload),

  getSingleDetails: (id) => axios.get(`form/${id}`),

  deleteItem: (id) => axios.delete(`form/${id}`),

  getSubmissionList: (params) => axios.get(`form/submissions`, {params}),
};

export default formAPI;
